<template>
  <div class="details presentation">
    <template v-for="(cval, ckey) in presentations">
      <div class="session_details" v-if="cval.session_id" :key="'back-' + ckey">
        <span @click="showDetails({ model: 'session', id: cval.session_id })">
          <font-awesome-icon :icon="['fas', 'caret-left']"/>
          {{ _.session }} 
        </span>
      </div>
      <b style="font-size: 16px; line-height: 19px;" :key="'title-' + ckey">
        <span v-if="cval.code">{{ cval.code }}&nbsp;</span>
        <span v-html="cval.title"></span>
      </b>
      <div v-if="cval.persons" class="persons" :key="'persons-' + ckey">
        <span v-for="(pval, pkey) in cval.persons.filter(person => person.role.value['in_reports'] === true)" :key="pkey">
          {{ pval.role.name }}: {{ pval.person.first_name }} {{ pval.person.last_name }}
          <span v-if="pval.person.city || pval.person.country"> (</span>
          <span v-if="pval.person.city">{{ pval.person.city }}</span>
          <span v-if="pval.person.city && pval.person.country && pval.person.country.value.display">, </span>
          <span v-if="pval.person.country && pval.person.country.value.display">{{ pval.person.country.value.kfz }}</span>
          <span v-if="pval.person.city || pval.person.country">)</span>
          <br>
        </span>
      </div>
      <div class="abstract" :key="'abstract-' + ckey">
        <div v-if="cval.abstract" v-html="cval.abstract"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { API_URL, SUBMISSION_SYSTEM_URL } from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['id'],
  data() {
    return {
      presentations: [],
    }
  },
  computed: {
    ...mapGetters(['details']),
  },
  async created() {
    const response = await this.axios.get(API_URL + '/presentations/' + this.id + '/details');
    let presentations = response.data;
    for (let i = 0; i < presentations.length; i++) {
      if (presentations[i].abstract_id) {
        const abstract = await this.axios.get(SUBMISSION_SYSTEM_URL.replace('{{id}}', presentations[i].abstract_id), { validateStatus: () => { return true }});
        presentations[i].abstract = abstract.data[presentations[i].abstract_id];
      }
    }
    this.presentations = presentations;
    this.setProgress(false);
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.details.presentation {
  padding: 12px;
  > .persons {
    margin-top: 4px;
  }
  > .abstract {
    margin-top: 6px;
    margin-bottom: 6px;
    > p {
      padding: 6px 0;
    }
    sub, sup {
      font-size: 75%;
      line-height: 0;
      position: relative;
      vertical-align: baseline;
    }
    sup {
      top: -0.5em;
    }
    sub {
      bottom: -0.25em;
    }
    table {
      border-collapse: collapse;
      border-spacing: 0;
      margin-top: 12px;
      th, td {
        text-align: left;
        vertical-align: top;
        padding: 6px;
        border: 1px solid #d4d4d4;
      }
    }
    > .results {
      > table {
        width: 100%;
      }
    }
  }
  .session_details {
    margin-bottom: 8px;
    > span {
      padding: 1px 4px 1px 4px;
      background: #e4e4e4;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
      border-radius: 4px;
      > svg {
        margin-right: 4px;
      }
    }
  }
}
</style>
